<template>
    <div class="study-list">
        <a href="javascript:;" v-for="(item,index) in list" :key="index" @click="getPlay(index, item.id)">
            <div class="video-image">
                <img :src="item.poster" :alt="item.title">
                <i class="icon i-live" v-if="$store.state.getCurrnet === item.id">播放中</i>
                <i class="play el-icon-video-play" v-else></i>
                <div class="play-time">{{item.videodurationstr}}</div>
            </div>
            <div class="title">{{item.title}}</div>
        </a>
    </div>
</template>

<script>
import jsonp from 'jsonp';

export default{
    name: 'StudyList',
    props:{
        list: Array
    },
    data(){
        return{
            currnet: this.$route.params.id
        }
    },
    created(){
        this.$store.state.getCurrnet = this.currnet;
    },
    methods:{
        getPlay(index, id){
            this.currnet = id;
            document.title = this.list[index].title;
            this.$store.state.getCurrnet = id;
            this.$emit('send', this.list[index]);        
        }
    }
}
</script>

<style lang="less" scoped>
    .study-list{
        padding: 0 0.3rem;
        display: flex;
        overflow-x: scroll;
        -webkit-box-pack: start;
        justify-content: start;
        flex-wrap: nowrap;
        a{
            width: 3.5rem;
            margin-right: 0.3rem;
        }
        i{
            color: #fff;
            position: absolute;
        }
        .play{
            font-size: 0.7rem;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-weight: bold;
        }
        img{
            width: 100%;
            border-radius: 0.15rem;
        }
        .video-image{
            width: 3.5rem;
            position: relative;
        }
        .play-time{
            position: absolute;
            right: 0.05rem;
            bottom: 0.05rem;
            border-radius: 0.25rem;
            background: linear-gradient(to right, #70befd , #3a7eff);
            color: #fff;
            padding: 0 0.15rem;
            font-size: 0.26rem;
        }
        .title{
            margin-top: 0.1rem;
            color: #333;
            font-size: 0.36rem;
        }
    }              
</style>   